import React, { useState, useRef } from "react";
import styled from "styled-components";
import XLSX from 'sheetjs-style';

import FetchModule from "../../Share/Network/FetchModule";
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

export default function MemberListExportModal(props) {
  const { onClickExit } = props;
  const { t, languageMode } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClickedValidMember, setIsClickedValidMember] = useState(false);
  const [isClickedExpiredMember, setIsClickedExpiredMember] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(t('myStoreSetting.memberExport.loadingValid'));
  const [width, setWidth] = useState(0);
  const [isEnd, setIsEnd] = useState(false);

  const ExitTextRef = useRef();

  // 취소버튼 호버링 //
  function exitButtonOnMouseOver() {
    ExitTextRef.current.style.color = theme.subText;
  }

  // 취소버튼 호버링 //
  function exitButtonOnMouseLeave() {
    ExitTextRef.current.style.color = theme.line;
  }

  // 다운로드 버튼 클릭시 //
  async function onClickDownloadButton() {
    if (!isClickedValidMember && !isClickedExpiredMember) return;

    await setIsLoading(true);

    const fetchModule = new FetchModule();
    (
    	async () => {
        let alive = [];
        let expired = [];

        if (isClickedValidMember) {
          await setLoadingText(t('myStoreSetting.memberExport.loadingValid'));

          const aliveResponseData = await fetchModule.postData('member/alive/', 'POST');
          
          if (aliveResponseData.status === 200) {
            alive = await aliveResponseData.data.slice();
            await setWidth(90);
          } 
        }

        if (isClickedExpiredMember) {
          await setLoadingText(t('myStoreSetting.memberExport.loadingExpired'));

          const expiredResponseData = await fetchModule.postData('member/expired/', 'POST');
          
          if (expiredResponseData.status === 200) {
            expired = await expiredResponseData.data.slice();
            await setWidth(200);
          }
        }
        await setLoadingText(t('myStoreSetting.memberExport.loadingFormat'));
        await setWidth(274);
        exportToExcel(alive, expired);
    	}
    )();
  }

  // XLSX 추출 //
  async function exportToExcel(alive, expired) {
    for (let i = 0; i < alive.length; i++) {
      alive[i].division = t('myStoreSetting.memberExport.validMember');
    }

    for (let i = 0; i < expired.length; i++) {
      expired[i].division = t('myStoreSetting.memberExport.expiredMember');
    }
    
    let mergeData = await alive.concat(expired);

    let finalData = [];
    
    for (let i = 0; i < mergeData.length; i++) {
      let userId = '';

      // Link Coach 연동이 되어있는경우 //
      if (!mergeData[i].linkCoachId.includes('None-')) {
        let divideId = mergeData[i].linkCoachId.split('.');

        for (let j = 1; j < divideId.length; j++) {
          if (j === divideId.length - 1) userId += divideId[j];
          else userId += divideId[j] + '.';
        }
        
        if (divideId[0] !== 'kakao'
          && divideId[0] !== 'google'
          && divideId[0] !== 'apple'
          && divideId[0] !== 'naver') {
            userId = divideId[0] + '.' + userId;
          }
      }

      let phone = formatPhoneNumber(mergeData[i].phone, mergeData[i].countryCode, languageMode) || 'None';
      let startDate = mergeData[i].startDate.split('T')[0];
      let endDate = mergeData[i].endDate.split('T')[0];

      finalData.push({
        division: mergeData[i].division,
        name: mergeData[i].name,
        gender: mergeData[i].gender === 'male' ? t('myStoreSetting.memberExport.male') : t('myStoreSetting.memberExport.female'),
        phone: phone,
        memberShipName: mergeData[i].memberShipName,
        startDate: startDate,
        endDate: endDate,
        memberDetail: mergeData[i].memberDetail,
      })
    }
    
    const ws = await XLSX.utils.json_to_sheet(finalData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Member")
    XLSX.writeFile(wb, t('myStoreSetting.memberExport.fileName'));

    await setLoadingText(t('myStoreSetting.memberExport.loadingComplete'));
    await setWidth(313);
    await setIsEnd(true);
  }

  // XLSX추출 후 닫기 버튼 클릭시 //
  function onClickExitAfterExport() {
    if (isEnd) {
      onClickExit();
    }
    else {
      alert(t('myStoreSetting.memberExport.loadingInProgress'));
    }
  }

  return (
    <TotalModalWrapper>
      <Modal>
        <ModalInnerWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('myStoreSetting.memberExport.title')}</Text>
          </TitleWrapper>
          {
            !isLoading &&
            <ExplanationWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('myStoreSetting.memberExport.description')}</Text>
            </ExplanationWrapper>
          }
          {
            isLoading ?
              <LoadingBarWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='pointer'>{loadingText}</Text>
                <LoadingBar>
                  <PersentBar width={width} />
                </LoadingBar>
              </LoadingBarWrapper>
              :
              <CheckBoxTotalWrapper>
                <CheckBoxWrapper onClick={() => setIsClickedValidMember(!isClickedValidMember)}>
                  <CheckBox isClicked={isClickedValidMember} />
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='pointer'>{t('myStoreSetting.memberExport.validMember')}</Text>
                </CheckBoxWrapper>
                <CheckBoxWrapper onClick={() => setIsClickedExpiredMember(!isClickedExpiredMember)}>
                  <CheckBox isClicked={isClickedExpiredMember} />
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='pointer'>{t('myStoreSetting.memberExport.expiredMember')}</Text>
                </CheckBoxWrapper>
              </CheckBoxTotalWrapper>
          }
          {
            isLoading ?
              <ButtonWrapper isLoading={isLoading}>
                <ExitButton onMouseOver={exitButtonOnMouseOver} onMouseLeave={exitButtonOnMouseLeave} onClick={onClickExitAfterExport}>
                  <ExitText ref={ExitTextRef}>{t('myStoreSetting.close')}</ExitText>
                </ExitButton>
              </ButtonWrapper>
              :
              <ButtonWrapper isLoading={isLoading}>
                <ExitButton onMouseOver={exitButtonOnMouseOver} onMouseLeave={exitButtonOnMouseLeave} onClick={onClickExit}>
                  <ExitText ref={ExitTextRef}>{t('myStoreSetting.cancel')}</ExitText>
                </ExitButton>
                <DownloadButton isValid={isClickedValidMember || isClickedExpiredMember} onClick={onClickDownloadButton}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('myStoreSetting.memberExport.download')}</Text>
                </DownloadButton>
              </ButtonWrapper>
          }
        </ModalInnerWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 371px;
  height: 248px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const ModalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 84.9%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 12px;
`;

const CheckBoxTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 16px;

  gap: 12px;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 15px;
  height: 15px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 4px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const LoadingBarWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 42px;

  gap: 8px;
`;

const LoadingBar = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 313px;
  height: 18px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 4px;
  background-color: ${props => props.theme.buttonFill};
`;

const PersentBar = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  border-radius: 4px;
  background-color: ${props => props.theme.subKey};

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: ${props => props.isLoading ? `42px` : `35px`};

  gap: 16px;

  width: 100%;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      border: 1px solid ${props => props.theme.subText};
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ExitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DownloadButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.isValid ? props.theme.subKey : props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.isValid ? props.theme.subKeyHover : props.theme.line};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;